const coreColor = {
    ui: {
        black: '#000000',
        white: '#FFFFFF',
        gray: {
            '0': '#FFFFFF',
            '5': '#FCFDFD',
            '10': '#F7F9FA',
            '20': '#F1F4F6',
            '30': '#DFE3E8',
            '40': '#C1C6CE',
            '50': '#98A0A9',
            '60': '#6E7680',
            '70': '#555B62',
            '80': '#3B3F44',
            '90': '#323539',
            '100': '#27282B',
            '110': '#1D1E20',
            '120': '#131619',
        },
        blue: {
            '10': '#F2F8FF',
            '20': '#D0E3FB',
            '30': '#A8CCF8',
            '40': '#7AB1F4',
            '50': '#4793F1',
            '60': '#0E72ED',
            '70': '#2057B1',
            '80': '#213C77',
            '90': '#1F3363',
            '100': '#1B2749',
        },
        orange: {
            '10': '#FFF7F2',
            '20': '#FFD1B9',
            '30': '#FFAB81',
            '40': '#FF8548',
            '50': '#FF5F0F',
            '60': '#CF4B0A',
            '70': '#9D3B0F',
            '80': '#6B2C0F',
            '90': '#59260F',
            '100': '#441E0D',
        },
        teal: {
            '10': '#E9FEFD',
            '20': '#D4FCFB',
            '30': '#61F6F2',
            '40': '#00B2AE',
            '50': '#009E9A',
            '60': '#009591',
            '70': '#007C7C',
            '80': '#007573',
            '90': '#006462',
            '100': '#003130',
            '110': '#002322',
            '120': '#001E1E',
        },
        purple: {
            '10': '#FAF7FD',
            '20': '#F7F2FB',
            '30': '#EBDDF6',
            '40': '#BB8CE0',
            '50': '#AD75DA',
            '60': '#A66BD7',
            '70': '#9053C2',
            '80': '#864EB5',
            '90': '#73439A',
            '100': '#38214C',
            '110': '#261735',
            '120': '#22132D',
        },
        red: {
            '10': '#FFF2F5',
            '20': '#FAD1D9',
            '30': '#F6AAB8',
            '40': '#F17E93',
            '50': '#ED4D6A',
            '60': '#E8173D',
            '70': '#AF1E30',
            '80': '#771D23',
            '90': '#621B1E',
            '100': '#491718',
        },
        yellow: {
            '10': '#FFF9F2',
            '20': '#F0DCC4',
            '30': '#E1BD93',
            '40': '#D19F61',
            '50': '#C28030',
            '60': '#B36200',
            '70': '#884B0A',
            '80': '#5D350E',
            '90': '#4D2D0E',
            '100': '#3B230C',
        },
        green: {
            '10': '#F2FFF6',
            '20': '#C9E7D2',
            '30': '#9ECEAD',
            '40': '#74B688',
            '50': '#4B9D64',
            '60': '#268543',
            '70': '#196830',
            '80': '#174823',
            '90': '#173C1F',
            '100': '#142E19',
        },
        steelblue: {
            '10': '#F6F9FC',
            '20': '#F0F4F9',
            '30': '#D8E3F0',
            '40': '#77A4CE',
            '50': '#5892C4',
            '60': '#478BBF',
            '70': '#2974A8',
            '80': '#286D9D',
            '90': '#265D85',
            '100': '#1A2D3E',
            '110': '#151F29',
            '120': '#131B24',
        },
    },
    brand: {
        blue: '#2D8CFF',
        purple: '#925DFF',
        bloom: '#0B5CFF',
        rose: '#FF0055',
        goldenrod: '#FFCD00',
        spearmint: '#00FF91',
        saffron: '#FF7A00',
        lavender: '#9D5BD3',
        agave: '#00F0EA',
    },
    accent: {
        r500: '#FD3D4A',
        r400: '#F46670',
        br600: '#CF5A35',
        o550: '#FF5F0F',
        o600: '#DC7929',
        o500: '#FF8422',
        gld500: '#C28030',
        y400: '#FFBF39',
        g400: '#66CC84',
        t500: '#14BCA0',
        t600: '#2BA09B',
        b500: '#2D8CFF',
        b600: '#1E71D6',
        b700: '#0956B5',
        b800: '#285081',
        bp400: '#A477FF',
        bp500: '#9D87C9',
        bp600: '#925DFF',
        p500: '#5B4FB0',
        p600: '#493AB7',
        gry100: '#F7F9FA',
        gry800: '#252A30',
    },
};
export default coreColor;
